// @ts-ignore
// @ts-nocheck
import React, { useEffect } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { path } from "../constants";
import { useCustomToast } from "../contexts/CustomToastContext";
import PublicHeader from "../components/Navbar/PublicHeader";
import CustomToast from "../components/CustomToast";
import { useDefaultContext } from "../contexts/UserContext";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

export const useAuth = () => {
  const authToken = localStorage.getItem("access_token");
  return !!authToken;
};

const PublicRoutes: React.FC = () => {






  const navigate = useNavigate();
  const { getUserProfile } = useDefaultContext();
  const token = useAuth();
  const { message } = useCustomToast();


  if(sessionStorage.getItem('redirect_url') && token){
     
      return  <Navigate to={'redirection'} replace /> 
  
      }else if(sessionStorage.getItem('pathType') && token){
        sessionStorage.removeItem('pathType')
        return  <Navigate to={path.PERSONAL_INFO} replace /> 
      } else if (token) {
        getUserProfile();
      // return  <Navigate to={path.KALP_PRODUCTS} replace /> 
      return  window.open(process.env.REACT_APP_PORTAL_URL+`?access_token=${localStorage.getItem(
      "access_token"
    )}&refresh_token=${localStorage.getItem("refresh_token")}`, "_self");

    
      }else{

        return <GoogleReCaptchaProvider
        reCaptchaKey={process.env.REACT_APP_KALP_RECAPTCHA||''}>
        {message.text && <CustomToast />}
        <PublicHeader />
        <Outlet />
      </GoogleReCaptchaProvider>
      }
   
};
export default PublicRoutes;
